import { Component } from '@angular/core';
import "../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../../node_modules/jquery/dist/jquery.js";
import "../../node_modules/bootstrap/dist/js/bootstrap.bundle.js";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Eastalents';
}
